<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="loaded ? item.model.category.name : ''"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (categoryChosen) {
      @if (loaded) {
        <tidy-card>
          <form [formGroup]="form">
            @if (!item?.consumable) {
              <tidy-row>
                <tidy-auto-complete
                  [icon]="'assets/svg/create.svg'"
                  [label]="'Name or Model #'"
                  formControlName="model"
                  [options]="models"
                  [form]="form.controls.model"
                  (action)="selectModel($event)"
                  [submitted]="submitted"
                  [errorMessage]="'Please enter a name or model #'" />
              </tidy-row>
            }
            @if (item?.consumable) {
              <tidy-row>
                <tidy-input
                  [icon]="'assets/svg/create.svg'"
                  [label]="'Name'"
                  formControlName="model"
                  [form]="form.controls.model"
                  [submitted]="submitted"
                  [errorMessage]="'Please enter a name'" />
              </tidy-row>
            }
            @if (isAddingNewModel) {
              @for (characteristic of characteristics; track characteristic; let index = $index) {
                <tidy-row>
                  <tidy-select
                    [icon]="'assets/svg/list.svg'"
                    [label]="('Select ' | translate) + characteristic.name"
                    [form]="form.controls['characteristic_' + index]"
                    [formControlName]="'characteristic_' + index"
                    (optionChange)="selectCharacteristic(characteristic, $event)"
                    [items]="characteristic.formData" />
                </tidy-row>
              }
            }
            <form [formGroup]="modelForm">
              @if (createNewModel) {
                <tidy-row class="extra-bottom-padding">
                  <tidy-input
                    [icon]="'assets/svg/create.svg'"
                    [label]="'Model Number'"
                    formControlName="newModel"
                    [form]="modelForm.controls.newModel"
                    [submitted]="submitted"
                    [errorMessage]="'Please enter the number of the new model'" />
                </tidy-row>
              }
            </form>
            @if (!item?.consumable) {
              <tidy-row>
                <tidy-select
                  [icon]="'assets/svg/calendar.svg'"
                  [label]="'Year Installed'"
                  [form]="form.controls.installationDate"
                  formControlName="installationDate"
                  [items]="installationDateItems" />
              </tidy-row>
            }
            @if (item?.consumable) {
              @if (!isRightSideContent) {
                <div class="two-column-form-row padding-bottom-5">
                  <tidy-input
                    [icon]="'assets/svg/cube.svg'"
                    [label]="'Min Quantity'"
                    formControlName="minQuantity"
                    [form]="form.controls.minQuantity"
                    inputMode="numeric"
                    [mask]="'number'"
                    [submitted]="submitted" />
                  <tidy-input
                    [icon]="'assets/svg/cube.svg'"
                    [label]="'Target Quantity'"
                    formControlName="maxQuantity"
                    [form]="form.controls.maxQuantity"
                    inputMode="numeric"
                    [mask]="'number'"
                    [submitted]="submitted" />
                </div>
                @if (!form.controls.minQuantity.valid && submitted) {
                  <tidy-row>
                    <tidy-error-message
                      [text]="'Please enter the minimum quantity'" />
                  </tidy-row>
                }
                @if (!form.controls.maxQuantity.valid && submitted) {
                  <tidy-row>
                    <tidy-error-message
                      [text]="'Please enter the target quantity to restock up to'" />
                  </tidy-row>
                }
                <tidy-row>
                  <tidy-input
                    [icon]="'assets/svg/cube.svg'"
                    [label]="'Current Quantity'"
                    formControlName="currentQuantity"
                    [form]="form.controls.currentQuantity"
                    inputMode="numeric"
                    [mask]="'number'" />
                </tidy-row>
                <tidy-row>
                  <tidy-input
                    [icon]="'assets/svg/cash.svg'"
                    [label]="'Min Restocking Price'"
                    formControlName="minRestockingPrice"
                    inputMode="numeric"
                    [mask]="'currencyMask'"
                    [form]="form.controls.minRestockingPrice" />
                </tidy-row>
                <tidy-row>
                  <tidy-input
                    [icon]="'assets/svg/cash.svg'"
                    [label]="'Max Restocking Price'"
                    formControlName="maxRestockingPrice"
                    inputMode="numeric"
                    [mask]="'currencyMask'"
                    [form]="form.controls.maxRestockingPrice"
                    [submitted]="submitted"
                    [errorMessage]="'Please enter the max restocking price'" />
                </tidy-row>
              }
              @if (isRightSideContent) {
                <div class="three-column-form-row padding-bottom-5">
                  <tidy-input
                    [icon]="'assets/svg/cube.svg'"
                    [label]="'Min Quantity'"
                    formControlName="minQuantity"
                    [form]="form.controls.minQuantity"
                    inputMode="numeric"
                    [mask]="'number'"
                    [submitted]="submitted"
                    [errorMessage]="'Please enter the minimum quantity'" />
                  <tidy-input
                    [icon]="'assets/svg/cube.svg'"
                    [label]="'Target Quantity'"
                    formControlName="maxQuantity"
                    [form]="form.controls.maxQuantity"
                    inputMode="numeric"
                    [mask]="'number'"
                    [submitted]="submitted"
                    [errorMessage]="'Please enter the target quantity to restock up to'" />
                  <tidy-input
                    [icon]="'assets/svg/cube.svg'"
                    [label]="'Current Quantity'"
                    formControlName="currentQuantity"
                    [form]="form.controls.currentQuantity"
                    inputMode="numeric"
                    [mask]="'number'" />
                </div>
                <div class="two-column-form-row padding-bottom-5">
                  <tidy-input
                    [icon]="'assets/svg/cash.svg'"
                    [label]="'Min Restocking Price'"
                    formControlName="minRestockingPrice"
                    inputMode="numeric"
                    [mask]="'currencyMask'"
                    [form]="form.controls.minRestockingPrice" />
                  <tidy-input
                    [icon]="'assets/svg/cash.svg'"
                    [label]="'Max Restocking Price'"
                    formControlName="maxRestockingPrice"
                    inputMode="numeric"
                    [mask]="'currencyMask'"
                    [form]="form.controls.maxRestockingPrice"
                    [submitted]="submitted"
                    [errorMessage]="'Please enter the max restocking price'" />
                </div>
              }
              <tidy-row>
                <tidy-input
                  [icon]="'assets/svg/cube.svg'"
                  [label]="'Opportunistic Order Level'"
                  formControlName="opportunisticOrderLevel"
                  [form]="form.controls.opportunisticOrderLevel"
                  inputMode="numeric"
                  [mask]="'number'" />
              </tidy-row>
              <tidy-row>
                <tidy-input
                  [icon]="'assets/svg/cart.svg'"
                  [label]="'Where to Order'"
                  formControlName="whereToOrder"
                  [form]="form.controls.whereToOrder" />
              </tidy-row>
              <tidy-row>
                <tidy-select
                  [icon]="'assets/svg/time.svg'"
                  [label]="'Delivery Timing Preferences'"
                  [form]="form.controls.deliveryTimingPreferences"
                  formControlName="deliveryTimingPreferences"
                  [items]="deliveryTimingPreferenceItems" />
              </tidy-row>
              <tidy-row>
                <tidy-input
                  [icon]="'assets/svg/create.svg'"
                  [label]="'Restocking Notes'"
                  formControlName="restockingNotes"
                  [form]="form.controls.restockingNotes" />
              </tidy-row>
            }
            @if (!item.photo_url) {
              <tidy-row [align]="'center'">
                <tidy-text
                  class="link"
                  [body]="'Add Photo'"
                  (action)="addImage()" />
              </tidy-row>
            }
            @if (item.photo_url) {
              <tidy-row class="extra-top-padding">
                <img [src]="item.photo_url">
              </tidy-row>
              <tidy-row [align]="'center'">
                <tidy-text
                  class="link red"
                  [body]="'Remove Photo'"
                  (action)="removeImage()" />
              </tidy-row>
            }
          </form>
        </tidy-card>
        @if (item?.consumable) {
          <tidy-restocking-brand-waterfall
            [brands]="preferredBrands"
            [submitted]="submitted"
            (brandsChange)="onPreferredBrandsChange($event)" />
        }
        @if (errorMessage) {
          <tidy-error-message
            [text]="errorMessage" />
        }
        <tidy-button
          [text]="'Update Item'"
          [action]="boundUpdateItem"
          class="primary" />
      }
    }

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
